import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-about-nmacc',
  templateUrl: './about-nmacc.component.html',
  styleUrls: ['./about-nmacc.component.css']
})
export class AboutNmaccComponent implements OnInit {
  baseUrl = environment.staticUrlForImgNew
  @Input() aboutDetails:any;
  constructor(private renderer: Renderer2) { }

  ngOnInit(): void {
  }

  async ngAfterViewInit() {
    try {
      await this.loadScript('assets/nycJs/jquery-3.3.1.min.js');

      if (!(window as any).jQuery) {
        throw new Error('jQuery not available globally');
      }
      
      await this.loadScript('assets/nycJs/main.js');
      await this.loadScript('assets/nycJs/wow.min.js');      

      console.log('All scripts loaded');
    } catch (error) {
      console.error('Script loading failed:', error);
    }   

  }
  loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const script = this.renderer.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      script.onload = () => {
        console.log(`${src} loaded`);
        resolve();
      };
      script.onerror = (err) => reject(err);
      this.renderer.appendChild(document.body, script);
    });
    
  }

}
